import { ImageWithEnlargedModalView } from "./ImageWithEnlargedModalView";

export default ImageWithEnlargedModalView;
